export default "__VITE_ASSET__MXUQ72dm__"